module.exports = __webpack_public_path__ + "img/i_lightbulb.82af8645.svg";